/**
 * Which encoder made a proxy or rendition, and how the source was decoded (1.2.1), in words for the Processing tab
 * and the Jobs list. The worker records `encoder` ('h264_videotoolbox', 'libx264', or 'libx264 (hardware failed: …)')
 * and, when hardware decoding was asked for, `decoder` ('hardware (videotoolbox)' or 'software (…)').
 */
const HARDWARE = /_(nvenc|qsv|vaapi|videotoolbox|amf|v4l2m2m)$/;

export function encoderText(encoder: unknown, decoder?: unknown): string | null {
  if (typeof encoder !== 'string' || !encoder) return null;
  // A fallback already says why: "libx264 (hardware failed: …)".
  const enc = encoder.includes(' (') ? encoder : `${encoder} (${HARDWARE.test(encoder) ? 'hardware' : 'software'})`;
  if (typeof decoder !== 'string' || !decoder) return `Encoded with ${enc}`;
  const hw = /^hardware \((.+)\)$/.exec(decoder);
  return `${hw ? `Decoded on hardware (${hw[1]})` : `Decoded in ${decoder}`}, encoded with ${enc}`;
}
